export default function Blog() {
  return (
    <div className="section">
      <h1>Blog</h1>
      <p>Latest updates about gold rates and tips.</p>
    </div>
  );
}